(function () {
    'use strict';

    // 后台元字段 key（如 backing_attachment）转展示名称（Backing Attachment）
    function titleCase(text) {
        return String(text).replace(/\b\w/g, function (ch) {
            return ch.toUpperCase();
        });
    }

    // 通用属性 (?) hover 提示：英文 + 中文
    (function initAttrTips() {
        var tips = document.querySelectorAll('.attr-tip');
        if (!tips.length) return;

        function buildTooltip(tip) {
            if (tip.querySelector('.attr-tip-box')) return;
            var en = tip.getAttribute('data-tip-en') || '';
            var zh = tip.getAttribute('data-tip-zh') || '';
            var box = document.createElement('span');
            box.className = 'attr-tip-box';
            box.innerHTML = '<span class="attr-tip-en">' + en + '</span>' +
                            (zh ? '<span class="attr-tip-zh">' + zh + '</span>' : '');
            tip.appendChild(box);
        }

        tips.forEach(buildTooltip);

        document.addEventListener('mouseenter', function (e) {
            var tip = e.target.closest && e.target.closest('.attr-tip');
            if (tip) tip.classList.add('show');
        }, true);
        document.addEventListener('mouseleave', function (e) {
            var tip = e.target.closest && e.target.closest('.attr-tip');
            if (tip) tip.classList.remove('show');
        }, true);
    })();

    var menuToggle = document.querySelector('.menu-toggle');
    var navLinks = document.querySelector('.nav-links');
    if (menuToggle && navLinks) {
        menuToggle.addEventListener('click', function () {
            var open = navLinks.classList.toggle('active');
            menuToggle.classList.toggle('active', open);
            menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        navLinks.querySelectorAll('a').forEach(function (a) {
            a.addEventListener('click', function () {
                navLinks.classList.remove('active');
                menuToggle.classList.remove('active');
                menuToggle.setAttribute('aria-expanded', 'false');
            });
        });
    }

    function initCarousel(root) {
        if (!root) return;
        var viewport = root.querySelector('.logos-container, .reviews-grid');
        var prev = root.querySelector('.carousel-arrow.prev');
        var next = root.querySelector('.carousel-arrow.next');
        if (!viewport || !prev || !next) return;

        var page = 0;
        var PER_VIEW = 2;
        var total = viewport.children.length;

        function maxPage() {
            return Math.max(0, Math.ceil(total / PER_VIEW) - 1);
        }

        function isMobile() {
            return window.matchMedia('(max-width: 767px)').matches;
        }

        function step() {
            return viewport.clientWidth;
        }

        function update() {
            prev.disabled = page === 0;
            next.disabled = page >= maxPage();
        }

        function move() {
            viewport.scrollTo({ left: page * step(), behavior: 'smooth' });
            update();
        }

        prev.addEventListener('click', function () {
            if (!isMobile()) return;
            page = Math.max(0, page - 1);
            move();
        });

        next.addEventListener('click', function () {
            if (!isMobile()) return;
            page = Math.min(maxPage(), page + 1);
            move();
        });

        var dragTimer;
        viewport.addEventListener('scroll', function () {
            if (!isMobile()) return;
            clearTimeout(dragTimer);
            dragTimer = setTimeout(function () {
                page = Math.round(viewport.scrollLeft / step());
                update();
            }, 120);
        });

        window.addEventListener('resize', function () {
            page = 0;
            viewport.scrollLeft = 0;
            update();
        });

        update();
    }

    document.querySelectorAll('.mobile-carousel').forEach(initCarousel);

    // 产品图切换
    document.addEventListener('click', function (e) {
        var thumb = e.target.closest('.thumb-item');
        if (!thumb) return;
        var gallery = thumb.closest('.product-gallery');
        if (!gallery) return;
        var mainImg = gallery.querySelector('.main-display-image img');
        var thumbImg = thumb.querySelector('img');
        if (!mainImg || !thumbImg) return;

        // 切换 active 状态
        gallery.querySelectorAll('.thumb-item').forEach(function (t) {
            t.classList.remove('active');
        });
        thumb.classList.add('active');

        // 切换主图（用大尺寸）
        var src = thumbImg.src;
        // 如果是 Shopify CDN 图片，替换尺寸为 large
        if (src.indexOf('?') > -1) {
            mainImg.src = src;
        } else {
            mainImg.src = thumbImg.src.replace(/_medium\./, '_large.');
        }
    });

    document.querySelectorAll('.faq-item').forEach(function (item) {
        var head = item.querySelector('.faq-head');
        if (!head) return;
        head.addEventListener('click', function () {
            item.classList.toggle('active');
        });
    });

    // ==================== Quote Cart ====================
    // 文件转 base64 工具；超过 maxBytes 直接跳过编码以免撑爆 localStorage
    function readFileAsDataURL(file, maxBytes) {
        maxBytes = maxBytes || 2 * 1024 * 1024;
        return new Promise(function (resolve) {
            if (!file || file.size > maxBytes) {
                resolve(null);
                return;
            }
            var reader = new FileReader();
            reader.onload = function (e) { resolve({ name: file.name, size: file.size, type: file.type, data: e.target.result }); };
            reader.onerror = function () { resolve(null); };
            reader.readAsDataURL(file);
        });
    }

    function humanSize(bytes) {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / 1024 / 1024).toFixed(2) + ' MB';
    }

    function renderAttachmentChips(container, files, onRemove) {
        if (!container) return;
        container.innerHTML = '';
        Array.prototype.forEach.call(files, function (f, i) {
            var chip = document.createElement('span');
            chip.className = 'attachment-chip';
            chip.innerHTML = '<span class="chip-name"></span><span class="chip-remove" data-i="' + i + '">&times;</span>';
            chip.querySelector('.chip-name').textContent = f.name + ' (' + humanSize(f.size) + ')';
            container.appendChild(chip);
        });
        container.querySelectorAll('.chip-remove').forEach(function (x) {
            x.addEventListener('click', function () {
                var idx = parseInt(x.getAttribute('data-i'), 10);
                onRemove(idx);
            });
        });
    }

    // 产品页附件选择器：保留 FileList 状态，提供预览与删除
    (function initProductAttachment() {
        var input = document.getElementById('product-attachment');
        var preview = document.getElementById('attachment-preview');
        if (!input || !preview) return;
        var state = [];
        function rerender() { renderAttachmentChips(preview, state, function (i) { state.splice(i, 1); rerender(); }); }
        input.addEventListener('change', function () {
            var added = Array.prototype.slice.call(input.files || []);
            added.forEach(function (f) { state.push(f); });
            input.value = '';
            rerender();
        });
        // 暴露给外部收集
        window.__quoteProductAttachments = function () { return state.slice(); };
    })();

    var QuoteCart = {
        key: 'quote_cart_items',
        contactKey: 'quote_contact',

        getItems: function () {
            var items = localStorage.getItem(this.key);
            return items ? JSON.parse(items) : [];
        },

        // 客户联系方式（产品页填写，cart 页回填）
        setContact: function (contact) {
            localStorage.setItem(this.contactKey, JSON.stringify(contact || {}));
        },

        getContact: function () {
            var raw = localStorage.getItem(this.contactKey);
            try {
                return raw ? JSON.parse(raw) : {};
            } catch (e) {
                return {};
            }
        },

        addItem: function (item) {
            var items = this.getItems();
            item.id = item.id || Date.now();
            items.push(item);
            localStorage.setItem(this.key, JSON.stringify(items));
            this.updateBadge();
        },

        removeItem: function (index) {
            var items = this.getItems();
            items.splice(index, 1);
            localStorage.setItem(this.key, JSON.stringify(items));
            this.updateBadge();
        },

        getCount: function () {
            return this.getItems().length;
        },

        getTotalQty: function () {
            var items = this.getItems();
            var total = 0;
            for (var i = 0; i < items.length; i++) {
                total += parseInt(items[i].quantity) || 0;
            }
            return total;
        },

        updateBadge: function () {
            var badge = document.querySelector('.cart-count');
            if (badge) {
                badge.textContent = this.getCount();
            }
        },

        formatCartText: function () {
            var items = this.getItems();
            if (items.length === 0) return '';

            var text = '\n\n--- Contact Information ---\n';
            var contact = this.getContact() || {};
            if (contact.name) text += 'Name: ' + contact.name + '\n';
            if (contact.email) text += 'Email: ' + contact.email + '\n';
            if (contact.company) text += 'Company: ' + contact.company + '\n';
            if (contact.phone) text += 'Phone: ' + contact.phone + '\n';

            text += '\n--- Quote Cart Items ---\n\n';
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                text += (i + 1) + '. ' + item.title + '\n';
                text += '   Quantity: ' + item.quantity + '\n';
                if (item.attributes && item.attributes.length) {
                    item.attributes.forEach(function (attr) {
                        if (attr.value) text += '   ' + attr.label + ': ' + attr.value + '\n';
                    });
                } else {
                    // 兼容改造前已加入购物车的旧数据
                    if (item.size) text += '   Size: ' + item.size + '\n';
                    if (item.backing) text += '   Backing: ' + item.backing + '\n';
                    if (item.plating) text += '   Plating: ' + item.plating + '\n';
                    if (item.packaging) text += '   Packaging: ' + item.packaging + '\n';
                }
                if (item.fast_ship) text += '   Fast Shipping: Yes\n';
                if (item.notes) text += '   Notes: ' + item.notes + '\n';
                if (item.attachments && item.attachments.length) {
                    text += '   Attachments:\n';
                    item.attachments.forEach(function (a) {
                        text += '     - ' + a.name + ' (' + humanSize(a.size) + ')' + (a.data ? ' [embedded]' : ' [metadata only]') + '\n';
                        if (a.data) text += '       data:' + a.data + '\n';
                    });
                }
                text += '\n';
            }
            text += 'Total Items: ' + items.length + '\n';
            text += 'Total Quantity: ' + this.getTotalQty() + '\n';
            return text;
        }
    };

    // 加入购物车 / 立即询价按钮（产品页）
// 加入购物车 / 立即询价按钮（产品页）
    function handleQuoteSubmit(btn) {
        var form = document.getElementById('quote-form');
        if (!form) {
            alert('Product form not found');
            return;
        }

        // 姓名、邮箱、电话必填；仅 Company 选填
        var nameEl = document.getElementById('inquiry-name');
        var emailEl = document.getElementById('inquiry-email');
        var companyEl = document.getElementById('inquiry-company');
        var phoneEl = document.getElementById('inquiry-phone');
        var contactName = nameEl ? nameEl.value.trim() : '';
        var contactEmail = emailEl ? emailEl.value.trim() : '';
        var contactCompany = companyEl ? companyEl.value.trim() : '';
        var contactPhone = phoneEl ? phoneEl.value.trim() : '';

        if (!contactName) {
            alert('Please enter your full name.');
            if (nameEl) nameEl.focus();
            return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactEmail)) {
            alert('Please enter a valid email address.');
            if (emailEl) emailEl.focus();
            return;
        }
        if (!contactPhone) {
            alert('Please enter your phone number.');
            if (phoneEl) phoneEl.focus();
            return;
        }

        // 通用收集后台动态自定义属性
        var attributes = [];
        var attrContainer = document.getElementById('custom-attributes');
        if (attrContainer) {
            attrContainer.querySelectorAll('.custom-attr-field').forEach(function (el) {
                attributes.push({
                    name: el.name,
                    label: titleCase(el.getAttribute('data-attr-label') || el.name),
                    value: el.value || ''
                });
            });
        }
        var colorInput = document.querySelector('.color-radio:checked');
        if (colorInput) {
            attributes.push({ name: 'color_option', label: 'Plating', value: colorInput.value });
        }

        // 获取 Uploadcare 生成的上传文件 CDN 链接
        var fileUrlEl = document.getElementById('uploadcare-file-url');
        var fileUrl = fileUrlEl ? fileUrlEl.value : '';

        // 构建邮件正文，POST 到 Shopify /contact 发送
        var productTitle = form.getAttribute('data-product-title') || 'Custom Product';
        var qty = form.quantity ? form.quantity.value : '100';
        var fastShip = form.fast_ship ? form.fast_ship.checked : false;
        var notes = form.notes ? form.notes.value : '';

        var body = '--- Product Inquiry ---\n';
        body += 'Product: ' + productTitle + '\n';
        body += 'Quantity: ' + qty + '\n';
        if (attributes.length > 0) {
            body += '\nOptions:\n';
            attributes.forEach(function (a) {
                if (a.value) body += '  ' + a.label + ': ' + a.value + '\n';
            });
        }
        if (fastShip) body += '\nFast Shipping: Yes\n';
        if (notes) body += 'Notes: ' + notes + '\n';

        // 拼接云端附件地址
        if (fileUrl) {
            body += '\n--- Uploaded Attachment ---\n';
            body += 'Download URL: ' + fileUrl + '\n';
        }

        body += '\n--- Contact Information ---\n';
        body += 'Name: ' + contactName + '\n';
        body += 'Email: ' + contactEmail + '\n';
        if (contactCompany) body += 'Company: ' + contactCompany + '\n';
        body += 'Phone: ' + contactPhone + '\n';

        btn.textContent = 'Sending...';
        btn.disabled = true;

        // 填充隐藏 contact form 并原生提交
        document.getElementById('hidden-contact-name').value = contactName;
        document.getElementById('hidden-contact-email').value = contactEmail;
        document.getElementById('hidden-contact-phone').value = contactPhone;
        document.getElementById('hidden-contact-company').value = contactCompany || '';
        document.getElementById('hidden-contact-body').value = body;

        var contactFormEl = document.getElementById('inquiry-contact-form');
        if (contactFormEl.requestSubmit) {
            contactFormEl.requestSubmit();
        } else {
            contactFormEl.submit();
        }
    }

    // 绑定 Shopify hCaptcha：隐藏表单没有用户交互（focusin），不会自动绑定；
    // 显式调用官方 protect API 后，提交时 provider 才会注入 token，
    // 否则会被 "Missing CAPTCHA token" 拦截页拒收
    var inquiryFormInit = document.getElementById('inquiry-contact-form');
    if (inquiryFormInit && window.Shopify && Shopify.captcha && Shopify.captcha.protect) {
        Shopify.captcha.protect(inquiryFormInit);
    }

    // 提交成功后 Shopify 跳回本页（return_to 带 inquiry_sent=1），显示成功提示
    if (location.search.indexOf('inquiry_sent=1') !== -1) {
        var successAfterRedirect = document.getElementById('inquiry-success');
        var quoteFormAfterRedirect = document.getElementById('quote-form');
        if (successAfterRedirect) {
            successAfterRedirect.style.display = 'block';
            if (quoteFormAfterRedirect) quoteFormAfterRedirect.style.display = 'none';
            successAfterRedirect.scrollIntoView({ behavior: 'smooth', block: 'center' });
            history.replaceState({}, '', location.pathname);
        }
    }

    document.addEventListener('click', function (e) {
        if (e.target.closest('.quote-action-btn')) {
            handleQuoteSubmit(e.target.closest('.quote-action-btn'));
        }
    });

    // 渲染购物车（cart 页面）
    function renderCart() {
        var items = QuoteCart.getItems();
        var container = document.getElementById('cart-items');
        var emptyEl = document.getElementById('cart-empty');
        var summaryItems = document.getElementById('summary-items');
        var summaryQty = document.getElementById('summary-qty');
        var hiddenInput = document.getElementById('cart-items-hidden');

        if (!container) return;

        if (summaryItems) summaryItems.textContent = items.length;
        if (summaryQty) summaryQty.textContent = QuoteCart.getTotalQty();
        if (hiddenInput) hiddenInput.value = QuoteCart.formatCartText();

        container.innerHTML = '';

        if (items.length === 0) {
            if (emptyEl) {
                emptyEl.style.display = 'block';
                container.appendChild(emptyEl);
            }
            return;
        }

        for (var i = 0; i < items.length; i++) {
            (function (index) {
                var item = items[index];
                var div = document.createElement('div');
                div.className = 'cart-item';

                var html = '';
                html += '<div class="cart-item-image">';
                if (item.image) {
                    html += '<img src="' + item.image + '" alt="' + item.title + '">';
                }
                html += '</div>';
                html += '<div class="cart-item-info">';
                html += '<h3>' + item.title + '</h3>';

                var variants = [];
                if (item.attributes && item.attributes.length) {
                    item.attributes.forEach(function (attr) {
                        if (attr.value) variants.push(attr.label + ': ' + attr.value);
                    });
                } else {
                    // 兼容改造前已加入购物车的旧数据
                    if (item.size) variants.push('Size: ' + item.size);
                    if (item.backing) variants.push('Backing: ' + item.backing);
                    if (item.plating) variants.push('Plating: ' + item.plating);
                    if (item.packaging) variants.push('Packaging: ' + item.packaging);
                }
                if (item.fast_ship) variants.push('Fast Shipping');

                if (variants.length > 0) {
                    for (var vi = 0; vi < variants.length; vi++) {
                        html += '<span class="cart-item-variant-line">' + variants[vi] + '</span>';
                    }
                }

                html += '<div class="cart-item-meta">';
                html += '<span class="cart-item-quantity">Qty: ' + item.quantity + '</span>';
                html += '</div>';
                html += '</div>';
                html += '<button type="button" class="cart-item-remove" data-index="' + index + '" aria-label="Remove">';
                html += '<span>×</span>';
                html += '</button>';

                div.innerHTML = html;
                container.appendChild(div);

                var removeBtn = div.querySelector('.cart-item-remove');
                if (removeBtn) {
                    removeBtn.addEventListener('click', function () {
                        QuoteCart.removeItem(index);
                        renderCart();
                    });
                }
            })(i);
        }
    }

    // 初始化
    QuoteCart.updateBadge();
    if (document.getElementById('cart-items')) {
        renderCart();
    }

    // 购物车明细的邮件拼接统一由 cart 页内联脚本处理（含 cart 级附件），
    // 这里不再重复追加，避免邮件里明细出现两次。

    // 多标签页同步
    window.addEventListener('storage', function () {
        QuoteCart.updateBadge();
        if (document.getElementById('cart-items')) {
            renderCart();
        }
    });
})();
